import { ProductPrice } from '~/Product';

import { ProductComputedPrice } from './ProductComputedPrice';

export class ReferencePrice {
	public constructor(
		public readonly sourcePrice: ProductPrice,
		public readonly calculatedPrice: ProductComputedPrice
	) {}
}
